import React, {useEffect} from 'react'
import {Alert, Box, CloseButton, useMultiStyleConfig} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import {CheckIcon} from '../../components/icons'

const CustomToast = ({message, status, onClose, duration = 5000}) => {
    const styles = useMultiStyleConfig('CustomToast', {variant: status})

    useEffect(() => {
        const timer = setTimeout(onClose, duration)
        return () => clearTimeout(timer)
    }, [onClose, duration])

    return (
        <Alert status={status} variant="left-accent" {...styles.container}>
            <CheckIcon {...styles.icon} />
            <Box flex="1" {...styles.title}>
                {message}
            </Box>
            <CloseButton {...styles.closeButton} onClick={onClose} />
        </Alert>
    )
}

CustomToast.propTypes = {
    message: PropTypes.string.isRequired,
    status: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    duration: PropTypes.number,
}

export default CustomToast
